var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99922 6.30275L2.84775 1.15128C2.37912 0.682647 1.61932 0.682647 1.15069 1.15128C0.682061 1.61991 0.682061 2.3797 1.15069 2.84833L7.15069 8.84833C7.61932 9.31696 8.37912 9.31696 8.84775 8.84833L14.8477 2.84833C15.3164 2.3797 15.3164 1.61991 14.8477 1.15128C14.3791 0.682647 13.6193 0.682647 13.1507 1.15128L7.99922 6.30275Z",
    fill: "#199EA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down_arrow.0b66b92a35a82335750ba363a9242621.svg";
export { ForwardRef as ReactComponent };